import React, { useMemo } from 'react';
import { CustomComponentsProps, CustomComponentsWrapperType } from '@website-editor/customComponents';
import { WebsiteEditorPhotoComponentFragment } from '@graphql/generated';
import { useAddPhototNavigations } from './hooks/useAddPhotoNavigation';
import { WebsiteEditorPhotoTelemetryProvider } from './Photo.telemetry';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { PhotoEditListItem } from './wrappers/PhotoEditListItem/PhotoEditListItem';

// Lazy load sub-components
const PhotoAddListItem = loadable(() => import(/* webpackChunkName: "content/websiteEditorPhotoAddListItem" */ './wrappers/PhotoAddListItem/PhotoAddListItem'), 'PhotoAddListItem');

const PhotoUpload = loadable(() => import('./components/PhotoUpload'), 'PhotoUpload');

export interface PhotoProps
  extends CustomComponentsProps,
    Readonly<{
      componentData: WebsiteEditorPhotoComponentFragment;
      isLastItem?: boolean;
    }> {}

export const Photo: React.FC<PhotoProps> = props => {
  const { wrapperType, componentData, ...restProps } = props;
  useAddPhototNavigations(props);

  const getRenderComponent = useMemo(() => {
    switch (wrapperType) {
      case CustomComponentsWrapperType.AddComponentList:
        return (
          <PhotoAddListItem
            {...restProps}
            componentData={componentData}
          />
        );
      case CustomComponentsWrapperType.EditComponentList:
        return (
          <PhotoEditListItem
            {...restProps}
            componentData={componentData}
          />
        );
      default:
        return (
          <PhotoUpload
            {...restProps}
            isEditMode
            isSingleComponent
          />
        );
    }
  }, [componentData, restProps, wrapperType]);

  return <WebsiteEditorPhotoTelemetryProvider>{getRenderComponent}</WebsiteEditorPhotoTelemetryProvider>;
};
